import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { UpdateLocation } from '../mutations/updateLocation.mutation';
import type { UpdateLocationMutation, UpdateLocationMutationVariables } from '../types';

export const useUpdateLocationMutation = (
  options?: MutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateLocation), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('organization'),
      });
    },
  });
};
